export enum ClientTemplateCodes {
  BASKET_SUMMARY_FOOTER = "basket_summary_footer",
  CPROD_OVERVIEW = "contract_product_overview"
}
